import React from "react";
import { useRef } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination,Autoplay } from "swiper";
import "../Assets/Additionalcss/Foundationcarousel.css"

function Foundationcarousel(){

    return(
    <>

<Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        autoplay={{
          delay:2000,
          disableOnInteraction:false
        }}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}
        modules={[Autoplay,EffectCoverflow, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src="https://testingapi.kdpfoundation.org/images/IMG_20220721_150308.jpg"></img>
        </SwiperSlide>

        <SwiperSlide>
          <img  src="https://testingapi.kdpfoundation.org/images/IMG_20220812_154148.jpg"></img>
        </SwiperSlide>

        <SwiperSlide>
        <img src="https://testingapi.kdpfoundation.org/images/IMG_20220715_132136.jpg"></img>
         
        </SwiperSlide>

        <SwiperSlide>
        <img  src="https://testingapi.kdpfoundation.org/images/IMG_20220715_131617.jpg"></img>
        </SwiperSlide>

        <SwiperSlide>
        <img  src="https://testingapi.kdpfoundation.org/images/IMG_20220708_101825469_HDR.jpg"></img>
        </SwiperSlide>

        <SwiperSlide>
        <img  src="https://testingapi.kdpfoundation.org/images/IMG_20210921_115246814_HDR.jpg"></img>
        </SwiperSlide>

        <SwiperSlide>
        <img src="https://testingapi.kdpfoundation.org/images/IMG_20220722_122231.jpg"></img>
        </SwiperSlide>


      </Swiper>

  </>

    )
}

export default Foundationcarousel;